<template>
  <div>
    <div class="main-container">
      <div
        class="
          dashboardAdmin-header
          d-flex
          align-items-center
          justify-content-between
        "
      >
        <div class="d-flex align-items-center">
          <div>
            <img
              @click="goBack"
              src="../../assets/img/feedbackform/backarrow.svg"
              class="pointer"
              alt=""
            />
          </div>
          <div class="dashboardAdmin-header-main-head ml-2">
            <span>{{ pageType }} Job</span>
          </div>
        </div>
      </div>
      <div class="createjob-main-container mt-3">
        <div
          v-if="!isOnlyHiringManager && !isHMLeadNotPreapproved"
          class="createjob-header w-100 d-flex align-items-center"
        >
          <div
            class="position-relative w-33 h-100 pointer"
            @click="setActiveTab('basic')"
          >
            <div
              :class="
                isBasic
                  ? 'active-createjob-tab-txt'
                  : 'inactive-createjob-tab-txt'
              "
              class="d-flex justify-content-center align-items-center h-90"
            >
              Basic Details
            </div>
            <div
              class="
                createjob-border-line
                d-flex
                justify-content-end
                align-items-end
                w-100
              "
            >
              <div class="createjob-tab-blueline w-50"></div>
              <div class="createjob-tab-image">
                <img
                  v-show="isBasicError"
                  src="../../assets/img/newcreatejob/errorbasic.svg"
                  alt=""
                />
                <img
                  v-show="!isBasicError && isBasicFilled"
                  src="../../assets/img/newcreatejob/activebasicdetail.svg"
                  alt=""
                />
                <img
                  v-show="!isBasicError && !isBasicFilled"
                  src="../../assets/img/newcreatejob/inactivebasic.svg"
                  alt=""
                />
              </div>
              <div
                class="w-50"
                :class="
                  isInterview || isAllocate || isPublish
                    ? 'createjob-tab-blueline'
                    : 'createjob-tab-greyline'
                "
              ></div>
            </div>
          </div>
          <div
            :class="roles.includes('EXTERNAL_ACCESS') && 'disable-inputField'"
            class="position-relative w-34 h-100 pointer"
            @click="
              !roles.includes('EXTERNAL_ACCESS')
                ? setActiveTab('interview')
                : ''
            "
          >
            <div
              :class="
                isInterview && !roles.includes('EXTERNAL_ACCESS')
                  ? 'active-createjob-tab-txt'
                  : 'inactive-createjob-tab-txt'
              "
              class="d-flex justify-content-center align-items-center h-90"
            >
              Interview Process
            </div>
            <div
              class="
                createjob-border-line
                d-flex
                justify-content-end
                align-items-end
                w-100
                h-90
              "
            >
              <div
                class="w-50"
                :class="
                  (isInterview || isAllocate || isPublish) &&
                  !roles.includes('EXTERNAL_ACCESS')
                    ? 'createjob-tab-blueline'
                    : 'createjob-tab-greyline'
                "
              ></div>
              <div class="createjob-tab-image">
                <img
                  v-show="isIpError && !roles.includes('EXTERNAL_ACCESS')"
                  src="../../assets/img/newcreatejob/errorip.svg"
                  alt=""
                />
                <img
                  v-show="
                    !isIpError &&
                    isIpFilled &&
                    !roles.includes('EXTERNAL_ACCESS')
                  "
                  src="../../assets/img/newcreatejob/activeip.svg"
                  alt=""
                />
                <img
                  v-show="
                    (!isIpError && !isIpFilled) ||
                    roles.includes('EXTERNAL_ACCESS')
                  "
                  src="../../assets/img/newcreatejob/inactiveip.svg"
                  alt=""
                />
              </div>
              <div
                class="w-50"
                :class="
                  (isAllocate || isPublish) &&
                  !roles.includes('EXTERNAL_ACCESS')
                    ? 'createjob-tab-blueline'
                    : 'createjob-tab-greyline'
                "
              ></div>
            </div>
          </div>
          <div
            :class="roles.includes('EXTERNAL_ACCESS') && 'disable-inputField'"
            class="position-relative w-33 h-100 pointer"
            @click="
              !roles.includes('EXTERNAL_ACCESS') ? setActiveTab('allocate') : ''
            "
          >
            <div
              :class="
                isAllocate && !roles.includes('EXTERNAL_ACCESS')
                  ? 'active-createjob-tab-txt'
                  : 'inactive-createjob-tab-txt'
              "
              class="d-flex justify-content-center align-items-center h-90"
            >
              Allocate
            </div>
            <div
              class="
                createjob-border-line
                d-flex
                justify-content-end
                align-items-end
                w-100
                h-90
              "
            >
              <div
                class="w-50"
                :class="
                  (isAllocate || isPublish) &&
                  !roles.includes('EXTERNAL_ACCESS')
                    ? 'createjob-tab-blueline'
                    : 'createjob-tab-greyline'
                "
              ></div>
              <div class="createjob-tab-image">
                <img
                  v-show="isAllocateError && !roles.includes('EXTERNAL_ACCESS')"
                  src="../../assets/img/newcreatejob/errorallocate.svg"
                  alt=""
                />
                <img
                  v-show="
                    isAllocateFilled &&
                    !isAllocateError &&
                    !roles.includes('EXTERNAL_ACCESS')
                  "
                  src="../../assets/img/newcreatejob/activeallocate.svg"
                  alt=""
                />
                <img
                  v-show="
                    (!isAllocateFilled && !isAllocateError) ||
                    roles.includes('EXTERNAL_ACCESS')
                  "
                  src="../../assets/img/newcreatejob/inactiveallocate.svg"
                  alt=""
                />
              </div>
              <div
                class="w-50"
                :class="
                  isPublish && !roles.includes('EXTERNAL_ACCESS')
                    ? 'createjob-tab-blueline'
                    : 'createjob-tab-greyline'
                "
              ></div>
            </div>
          </div>

          <div
            :class="roles.includes('EXTERNAL_ACCESS') && 'disable-inputField'"
            class="position-relative w-33 h-100 pointer"
            @click="
              !roles.includes('EXTERNAL_ACCESS') ? setActiveTab('publish') : ''
            "
          >
            <div
              :class="
                isPublish && !roles.includes('EXTERNAL_ACCESS')
                  ? 'active-createjob-tab-txt'
                  : 'inactive-createjob-tab-txt'
              "
              class="d-flex justify-content-center align-items-center h-90"
            >
              Publish Job
            </div>
            <div
              class="
                createjob-border-line
                d-flex
                justify-content-end
                align-items-end
                w-100
              "
            >
              <div
                class="w-50"
                :class="
                  isPublish && !roles.includes('EXTERNAL_ACCESS')
                    ? 'createjob-tab-blueline'
                    : 'createjob-tab-greyline'
                "
              ></div>
              <div class="createjob-tab-image">
                <img
                  v-show="isPublishError && !roles.includes('EXTERNAL_ACCESS')"
                  src="../../assets/img/newcreatejob/error-publish.svg"
                  alt=""
                />
                <img
                  v-show="
                    (!isPublishFilled && !isPublishError) ||
                    roles.includes('EXTERNAL_ACCESS')
                  "
                  src="../../assets/img/newcreatejob/inactive-publisj.svg"
                  alt=""
                />
                <img
                  v-show="
                    isPublishFilled &&
                    !isPublishError &&
                    !roles.includes('EXTERNAL_ACCESS')
                  "
                  src="../../assets/img/newcreatejob/publish-job-filled.svg"
                  alt=""
                />
              </div>
              <div
                class="w-50"
                :class="
                  isPublish && !roles.includes('EXTERNAL_ACCESS')
                    ? 'createjob-tab-blueline'
                    : 'createjob-tab-greyline'
                "
              ></div>
            </div>
          </div>
        </div>
        <div
          :class="
            isOnlyHiringManager || isHMLeadNotPreapproved
              ? 'createjob-body-hiring-container'
              : 'createjob-body-container'
          "
        >
          <FormShimmer v-if="shimmerLoader" />
          <BasicDetails
            v-else-if="currentTab === 'basic'"
            :customFields="customFields"
            :touchedFields="touchedFields"
            :basicArray="basicArray"
            :advanceArray="advanceArray"
            :newObject="jobData"
            :validations="validations"
            :basicErrorMap="basicErrorMap"
            :savedOpeningsCount="savedOpeningsCount"
            :writeButtonDisabled="writeButtonDisabled"
            :showAILoader="showAILoader"
            :isOnlyLeadRecruiter="isOnlyLeadRecruiter"
            @write-with-hire3x="writeWithHire3x"
            @error-check="updateBasicError"
            @set-value="setValue"
            @set-touched-fields="setTouchValue"
            @update-error-basic="updateErrorBasic"
            @update-check="updateCheck = true"
            @job-title-error="setJobTitleError"
          />
          <InterviewProcess
            v-else-if="currentTab === 'interview'"
            @delete-test="deleteTest"
            @ip-selected="populateIpData"
            @feedback-selected="populateFeedbackData"
            @save-tests="saveTests"
            @save-config-data="saveConfigData"
            @switch-to-ip="switchToIP"
            @generate-data="generatePayload"
            @select-round="(roundID) => (currentRoundID = roundID)"
            @delete-feedback="handleDeleteFeedback"
            @delete-interview="handleDeleteInterview"
            @populate-allocate="addRecruiterAfterInterview"
            :savedIP="interviewProcess"
            :validateObj="$v"
            :assessmentList="assessmentRounds"
            :faceToFaceList="faceToFaceRounds"
            :processMap="processMap"
            :interviewProcessID="interviewProcessID"
            :savedFeedback="savedFeedback"
            :feedbackFormID="feedbackFormID"
            :isFeedbackFormPresent="isFeedbackFormPresent"
            :isSaveAndApprove="isSaveAndApprove"
            :jobData="jobData"
            :allocateData="allocateData"
            :platformData="platformData"
            :viewData="{ advanceArray, basicArray }"
            :currentRoundID="currentRoundID"
            :currentRoundIndex="currentRoundIndex"
            :currentRoundType="currentRoundType"
            :isJdApproved="isJdApproved"
          />
          <Allocate
            v-else-if="currentTab === 'allocate'"
            :allocateData="allocateData"
            :currentRecuiterData="currentRecuiterData"
            :positions="positions"
            :currentVendorData="currentVendorData"
            :validationObj="$v"
            :interviewProcess="interviewProcess"
            :tempVendor="tempVendor"
            :jobData="jobData"
            :commonVendorData="commonVendorData"
            :savedOpeningsCount="savedOpeningsCount"
            :positionBarPercentage="positionBarPercentage"
            :isJdApproved="isJdApproved"
            :applyToAll="applyToAll"
            @calc-status-perc="getPositionStatusBar"
            @apply-changes-to-all="applyChangesToAll"
            @toggle-apply-to-all="toggleApplyToAll"
            @update-assigned-to="onUpdateAssignedTo"
            @add-recruiter="addRecruiter"
            @delete-recruiter="deleteRecruiter"
            @remove-panel="removePanel"
            @remove-vendor="removeVendor"
            @check-allocate="() => triggerCompute++"
            @clear-vendor="clearVendor"
            @set-openings-count="
              savedOpeningsCount = parseInt(jobData.openingsCount)
            "
            @delete-recruiter-reload="reloadWindow"
          />
          <PublishJob
            v-else-if="currentTab === 'publish'"
            :validationObj="$v"
            :isCreate="isCreate"
            :costPerInterview="costPerInterview"
            :totalCredits="totalCredits"
            :interviewExceeded="interviewExceeded"
            :minIntrw="minIntrw"
            :jobData="platformData"
            :assessIntProcess="assessIntProcess"
            :roles="roles"
            @get-credits="getCreditsInfo('refresh')"
          />
        </div>
        <div
          class="
            pff-footer-container
            d-flex
            align-items-center
            justify-content-between
            px-3
            pb-3
          "
        >
          <div>
            <div
              v-if="!isOnlyHiringManager && !isHMLeadNotPreapproved"
              class="newprimarybtn"
            >
              <b-button
                :disabled="roles.includes('EXTERNAL_ACCESS')"
                class="padding-4-21"
                @click="!roles.includes('EXTERNAL_ACCESS') ? titleCheck() : ''"
              >
                Save
              </b-button>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <div class="newoutline">
              <b-button
                variant="padding-4-21 outline-primary mr-3"
                @click="goBack"
                >Cancel</b-button
              >
            </div>

            <div class="newprimarybtn">
              <b-button
                :disabled="buttonLoader"
                class="padding-4-21"
                @click="!buttonLoader ? buttonClickHandler() : ''"
              >
                <!-- <span :class="buttonLoader && 'invisible-text'"> -->
                {{ buttonLabel }}
                <!-- </span> -->
              </b-button>
              <!-- <div class="common-button-loader" v-if="buttonLoader">
                <Loader from="CreateJob" />
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <ConfirmModal
      :confirmModal="confirmModal"
      button="Publish"
      header="Publish Job"
      msg="Are you sure you want to publish this job?"
      btnName="Save to Draft"
      :imageSrc="require('../../assets/img/feedbackform/confirmIcon.svg')"
      @close-confirm="confirmModal = false"
      @save-draft="
        confirmModal = false;
        titleCheck();
      "
      @handle-submit="publishHMLeadJob"
    />
  </div>
</template>

<script>
// import Loader from "@/components/fixedcomponents/Loader.vue";
import errorModal from "../../components/mixin/toast";
import { mapMutations, mapGetters } from "vuex";
import InterviewProcess from "./Forms/InterviewProcess.vue";
import Allocate from "./Forms/Allocate.vue";
import BasicDetails from "./Forms/Basic.vue";
import ConfirmModal from "../InterviewProcess/ConfirmModal.vue";
import PublishJob from "./Forms/PublishJob.vue";

import { convertTime } from "../../controllers/workbench/helpers";

import {
  dynamicRules,
  getCustomFields,
  validateField,
} from "../../utils/customFields";
import {
  between,
  requiredIf,
  required,
  maxLength,
  minLength,
  minValue,
  integer,
} from "vuelidate/lib/validators";
import {
  checkTestAutocorrected,
  createJob,
  getJobByID,
  getPanelIDs,
} from "../../utils/apiClient/jobs";
import FormShimmer from "../../components/fixedcomponents/FormShimmer.vue";
import {
  uploadDocumentAPI,
  editConfig,
  getintprocess,
  generatePositionIds,
  aiJobDescription,
  getPositionIDStatus,
  updateApplyToAll,
  patchJobDesc,
  getCreditsInfo,
} from "../../utils/apiFunctions";
export default {
  name: "Job",
  mixins: [errorModal],
  data() {
    return {
      buttonLoader: false,
      confirmModal: false,
      showAILoader: false,
      isBasicError: false,
      updateCheck: false,
      updateCheckHMandLead: false,
      basicErrorMap: {},
      panelIDs: {},
      triggerCompute: 0,
      finalStatus: null,
      currentStatus: null,
      savedOpeningsCount: null,
      oldOpeningsCount: null,
      basicError: false,
      isBasicFilled: false,
      pageType: null,
      isSaveAndApprove: false,
      shimmerLoader: false,
      applyToAll: false,
      jobTitleError: true,
      currentTab: "basic",
      currentRoundID: null,
      created: false,
      customFields: [],
      basicArray: [],
      advanceArray: [],
      touchedFields: {},
      jobData: {},
      jobDataCopy: {},
      positionStatusBar: {},
      positionBarPercentage: [],
      tempVendor: [],
      allocateKeys: [
        "showAllPanelist",
        "assignedPanelist",
        "assignedTo",
        "recruiterConfig",
        "vendorConfig",
        "vendor",
        "userFolderIDs",
      ],
      currentRecuiterData: [
        {
          panelist: null,
          recruiterData: null,
          selectedRecruiter: "",
          showRecDropDown: false,
          selectedPanels: ["internal"],
          positionIDs: [],
        },
      ],
      positions: [],
      currentVendorData: {
        vendor: null,
        noOfRoundsToTake: null,
        noOfCandidatesToPush: null,
        taggedRecruiters: [],
        panelist: null,
        showVendor: false,
        showRounds: false,
        showRec: false,
        showPanel: false,
      },
      commonVendorData: {
        vendor: [],
        taggedRecruiters: [],
        panelist: null,
        noOfCandidatesToPush: null,
        noOfRoundsToTake: null,
      },
      allocateData: {
        showAllPanelist: true,
        assignedPanelist: [],
        assignedTo: [],
        requiredPanel: "allpanelist",
        recruiterConfig: {
          selectAll: false,
          common: false,
          panelist: null,
          requiredRecruiter: "partrecruiter",
        },
        vendorConfig: {
          common: true,
        },
        vendor: [],
        userFolderIDs: {
          Panelist: [],
          Recruiters: [],
        },
      },
      platformData: {
        openToPublic: false,
        carrerPage: false,
        linkedIn: false,
        naukri: false,
        automatic: false,
        mailNotification: true,
        textNotification: false,
        whatsAppNotification: false,
        threshold: 50,
        maxCheatingPercentage: 50,
        manualReview: false,
        noOfInterviews: null,
        meetingPlatform: "vccl",
      },
      minIntrw: 0,
      totalCredits: null,
      costPerInterview: null,
      validations: {},
      interviewProcess: null,
      assessmentRounds: [],
      assessmentRoundsCopy: [],
      faceToFaceRounds: [],
      faceToFaceRoundsCopy: [],
      processMap: {},
      page: 0,
      interviewProcessID: "",
      feedbackFormID: "",
      savedFeedback: null,
    };
  },
  validations() {
    const isEndDateAfterStartDate = (value, siblings) => {
      const startDate = new Date(siblings.openTestdt);
      const endDate = new Date(value);
      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        return true;
      }
      return endDate > startDate;
    };
    const isStartDateBeforeEndDate = (value, siblings) => {
      const endDate = new Date(siblings.closeTestdt);
      const startDate = new Date(value);

      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        return true;
      }
      return endDate > startDate;
    };
    const durationError = (value, siblings) => {
      const startDate = new Date(siblings.openTestdt);
      const endDate = new Date(siblings.closeTestdt);

      // Check if either date is invalid
      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        return true;
      }

      // Calculate the difference in minutes between endDate and startDate
      const diffInMinutes = (endDate - startDate) / (1000 * 60);

      // Check if the duration value is less than or equal to the difference
      return value <= diffInMinutes;
    };
    const isEndDateAfterStartDatef2f = (value, siblings) => {
      const startDate = new Date(siblings.startDate);
      const endDate = new Date(value);
      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        return true;
      }
      return endDate >= startDate;
    };
    const isStartDateBeforeEndDatef2f = (value, siblings) => {
      const endDate = new Date(siblings.endDate);
      const startDate = new Date(value);

      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        return true;
      }
      return endDate >= startDate;
    };

    const lessThanTakenCount = (value) => {
      if (this.platformData.automatic) {
        return value > this.minIntrw;
      } else return true;
    };

    return {
      currentVendorData: {
        vendor: {
          required: requiredIf(
            () =>
              !this.allocateData.vendorConfig.common && !this.tempVendor.length
          ),
        },
        noOfRoundsToTake: {
          required: requiredIf(
            () =>
              !this.allocateData.vendorConfig.common && !this.tempVendor.length
          ),
        },
        noOfCandidatesToPush: {
          required: requiredIf(
            () =>
              !this.allocateData.vendorConfig.common && !this.tempVendor.length
          ),
          minValue: minValue(1),
          maxLength: maxLength(10),
        },
        taggedRecruiters: {
          required: requiredIf(
            () =>
              !this.allocateData.vendorConfig.common && !this.tempVendor.length
          ),
        },
        panelist: {
          required: requiredIf(
            () =>
              !this.allocateData.vendorConfig.common &&
              !this.tempVendor.length &&
              this.currentVendorData.noOfRoundsToTake !== null &&
              this.currentVendorData.noOfRoundsToTake > 0
          ),
        },
      },
      commonVendorData: {
        taggedRecruiters: {
          required: requiredIf(
            () =>
              this.commonVendorData.vendor.length &&
              this.allocateData.vendorConfig.common &&
              this.isSaveAndApprove
          ),
        },
        panelist: {
          required: requiredIf(
            () =>
              this.commonVendorData.vendor.length &&
              this.allocateData.vendorConfig.common &&
              this.commonVendorData.noOfRoundsToTake !== 0 &&
              this.isSaveAndApprove
          ),
        },
        noOfCandidatesToPush: {
          required: requiredIf(
            () =>
              this.commonVendorData.vendor.length &&
              this.allocateData.vendorConfig.common &&
              this.isSaveAndApprove
          ),
          minValue: minValue(1),
          maxLength: maxLength(10),
        },
        noOfRoundsToTake: {
          required: requiredIf(
            () =>
              this.commonVendorData.vendor.length &&
              this.allocateData.vendorConfig.common &&
              this.isSaveAndApprove
          ),
        },
      },
      tempVendor: {
        required: requiredIf(
          () =>
            this.isSaveAndApprove &&
            !this.allocateData.vendorConfig.common &&
            !this.isCurrentVenFilled
        ),
        $each: {
          noOfCandidatesToPush: {
            required: requiredIf(() => !this.allocateData.vendorConfig.common),
            minValue: minValue(1),
            maxLength: maxLength(10),
          },
          taggedRecruiters: {
            required: requiredIf(() => !this.allocateData.vendorConfig.common),
          },
          panelist: {
            required: requiredIf(function (vendor) {
              return vendor.noOfRoundsToTake > 0;
            }),
          },
        },
      },
      currentRecuiterData: {
        $each: {
          panelist: {
            required,
          },
          recruiterData: {
            required,
          },
          positionIDs: {
            required,
            minLength: minLength(1),
          },
        },
      },
      allocateData: {
        requiredPanel: {
          required: requiredIf(() => this.isSaveAndApprove),
        },
        recruiterConfig: {
          requiredRecruiter: {
            required: requiredIf(() => this.isSaveAndApprove),
          },
          panelist: {
            required: requiredIf(
              () =>
                this.isSaveAndApprove &&
                this.allocateData.recruiterConfig.common &&
                this.allocateData.recruiterConfig.requiredRecruiter ===
                  "partrecruiter"
            ),
          },
        },
        assignedTo: {
          required: requiredIf(
            () =>
              this.isSaveAndApprove &&
              this.allocateData.recruiterConfig.common &&
              this.allocateData.recruiterConfig.requiredRecruiter ===
                "partrecruiter"
          ),
        },
        assignedPanelist: {
          required: requiredIf(
            () =>
              this.isSaveAndApprove &&
              this.allocateData.requiredPanel === "partpanelist"
          ),
        },
        vendor: {
          required: requiredIf(() => this.isSaveAndApprove),
        },
      },
      interviewProcess: {
        required: requiredIf(() => this.isSaveAndApprove),
        feedbackFormID: {
          required: requiredIf(() => {
            return (
              (!this.isJdApproved &&
                this.isSaveAndApprove &&
                this.feedbackFormID === "") ||
              (this.isJdApproved &&
                this.jobData.interviewProcess?.feedbackFormID &&
                this.feedbackFormID === "") ||
              (this.isOnlyLeadRecruiter && this.feedbackFormID === "") ||
              (this.isHMLeadPreapproved && this.feedbackFormID === "")
            );
          }),
        },
      },
      assessmentRounds: {
        $each: {
          openTestdt: {
            required: requiredIf(() => this.isSaveAndApprove),
            isStartDateBeforeEndDate: (value, siblings) =>
              isStartDateBeforeEndDate(value, siblings),
          },
          closeTestdt: {
            required: requiredIf(() => this.isSaveAndApprove),
            isDateValid: (value) => {
              const selectedDate = new Date(value);
              const currentDate = new Date();
              if (selectedDate == "Invalid Date") return true;
              else return selectedDate > currentDate;
            },
            isEndDateAfterStartDate: (value, siblings) =>
              isEndDateAfterStartDate(value, siblings),
          },
          passingPercentage: {
            required: requiredIf(() => this.isSaveAndApprove),
            integer,
            between: between(1, 100),
          },
          duration: {
            required: requiredIf(() => this.isSaveAndApprove),
            integer,
            minValue: minValue(5),
            durationError: (value, siblings) => durationError(value, siblings),
          },
          selectedtests: {
            required: requiredIf(() => this.isSaveAndApprove),
          },
          configID: {
            required: requiredIf((currentRound) => {
              return (
                currentRound.selectedtests.length > 0 && this.isSaveAndApprove
              );
            }),
          },
          selevaluator: {
            required: requiredIf((currentRound) => {
              return (
                currentRound.selectedtests.length > 0 &&
                currentRound.isEvalRequired &&
                this.isSaveAndApprove
              );
            }),
          },
        },
      },
      faceToFaceRounds: {
        $each: {
          startDate: {
            required: false,
            isStartDateBeforeEndDatef2f: (value, siblings) =>
              isStartDateBeforeEndDatef2f(value, siblings),
          },
          endDate: {
            required: false,
            isDateValid: (value) => {
              const selectedDate = new Date(value);
              const currentDate = new Date();
              currentDate.setHours(0, 0, 0, 0);
              if (selectedDate == "Invalid Date") return true;
              else return selectedDate > currentDate;
            },
            isEndDateAfterStartDatef2f: (value, siblings) =>
              isEndDateAfterStartDatef2f(value, siblings),
          },
          duration: {
            required: false,
            integer,
            minValue: minValue(5),
          },
        },
      },
      platformData: {
        noOfInterviews: {
          required: requiredIf(() => this.platformData.automatic),
          minValue: () => (this.platformData.automatic ? minValue(1) : true),
          lessThanTakenCount: (value) => lessThanTakenCount(value),
        },
        threshold: {
          minValue: minValue(0),
        },
        maxCheatingPercentage: {
          minValue: minValue(0),
        },
      },
    };
  },
  components: {
    BasicDetails,
    InterviewProcess,
    Allocate,
    PublishJob,
    FormShimmer,
    ConfirmModal,
    // Loader,
  },
  watch: {
    jobData: {
      handler() {
        this.compareJobData();
      },
      deep: true, // Enable deep watching
    },
    assessmentRounds: {
      handler() {
        this.compareJobData();
      },
      deep: true,
    },
    faceToFaceRounds: {
      handler() {
        this.compareJobData();
      },
      deep: true,
    },
    "allocateData.requiredPanel"(newValue) {
      if (newValue === "nopanelist") {
        this.currentRecuiterData.forEach((recruiter) => {
          recruiter.selectedPanels = recruiter.selectedPanels.filter(
            (panel) => panel !== "internal"
          );
        });
      }
    },
  },
  computed: {
    ...mapGetters("jobDescriptionVUEX", {
      getCustomerDetail: "getCustomerDetail",
      getJobData: "getJobData",
      getSavedInterview: "getSavedInterview",
      getSavedFeedBack: "getSavedFeedBack",
      getAssesmentData: "getAssesmentData",
    }),
    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
      thirdPartyData: "getThirdPartyData",
    }),
    ...mapGetters({ roles: "roles" }),
    ...mapGetters("jobDescriptionVUEX", {
      customerDetail: "getCustomerDetail",
    }),
    ...mapGetters("userVUEX", {
      thirdPartyData: "getThirdPartyData",
    }),
    assessIntProcess() {
      return this.assessmentRounds.length != 0;
    },
    isOnlyHiringManager() {
      return (
        this.thirdPartyData.configuration.jobApprovalStage === "BASIC_INFO" &&
        this.customerDetail.manager &&
        !this.customerDetail.lead
      );
    },
    isOnlyLeadRecruiter() {
      return (
        this.thirdPartyData.configuration.jobApprovalStage === "BASIC_INFO" &&
        this.customerDetail.lead &&
        !this.customerDetail.manager
      );
    },
    isHMLeadNotPreapproved() {
      return (
        this.thirdPartyData.configuration.jobApprovalStage === "BASIC_INFO" &&
        this.customerDetail.lead &&
        this.customerDetail.manager &&
        (this.isCreate || !this.jobData.preApproved)
      );
    },
    isHMLeadPreapproved() {
      return (
        this.thirdPartyData.configuration.jobApprovalStage === "BASIC_INFO" &&
        this.customerDetail.lead &&
        this.customerDetail.manager &&
        this.jobData.preApproved
      );
    },
    isJdApproved() {
      return this.jobData.approved;
    },
    writeButtonDisabled() {
      if (this.jobData.title && this.jobData.skills.length) {
        return false;
      }
      return true;
    },
    buttonLabel() {
      if (
        (this.isOnlyLeadRecruiter || this.isHMLeadPreapproved) &&
        this.isPublish
      ) {
        return "Publish Job";
      } else if (
        (this.isOnlyHiringManager || this.isHMLeadNotPreapproved) &&
        this.isCreate
      ) {
        return "Save and Send for Approval";
      } else if (
        (this.isOnlyHiringManager || this.isHMLeadNotPreapproved) &&
        !this.isCreate
      ) {
        return "Update and Send for Approval";
      }
      if (this.roles.includes("EXTERNAL_ACCESS")) {
        return "Update and Send for Approval";
      }
      if (!this.isPublish) {
        return "Next";
      }
      if (this.pageType == "Activate") {
        return "Activate and Send for Approval";
      }
      if (this.isCreate) {
        return "Save and Send for Approval";
      }
      if (this.updateCheck || this.currentStatus === "5") {
        return "Update and Send for Approval";
      }
      return "Update";
    },
    isAllFilled() {
      return (
        !this.basicError &&
        this.isBasicFilled &&
        !this.isIpError &&
        this.isIpFilled &&
        this.isAllocateFilled &&
        !this.isAllocateError
      );
    },
    isJobOpenings() {
      return (
        this.jobData.openingsCount !== null && this.jobData.openingsCount !== ""
      );
    },
    isFeedbackFormPresent() {
      return !!this.jobData?.interviewProcess?.feedbackFormID;
    },
    currentRoundIndex() {
      return this.currentRoundID !== null
        ? this.processMap[this.currentRoundID].index
        : 0;
    },
    currentRoundType() {
      return this.currentRoundID !== null
        ? this.processMap[this.currentRoundID].type
        : "";
    },
    isInterview() {
      return this.currentTab === "interview";
    },
    isBasic() {
      return this.currentTab === "basic";
    },
    isAllocate() {
      return this.currentTab === "allocate";
    },
    isPublish() {
      return this.currentTab === "publish";
    },
    isIpSelected() {
      return (
        this.interviewProcess !== null &&
        Object.keys(this.interviewProcess).length
      );
    },
    isCreate() {
      return this.pageType === "Create";
    },
    isActiveOrOpen() {
      return this.pageType === "Activate" || this.pageType === "Re-Open";
    },
    isAllocateFilled() {
      const {
        requiredPanel,
        assignedPanelist,
        recruiterConfig,
        assignedTo,
        vendorConfig,
        vendor,
      } = this.allocateData;
      const isPanelFilled =
        requiredPanel === "allpanelist" ||
        requiredPanel === "nopanelist" ||
        (requiredPanel === "partpanelist" && assignedPanelist.length);
      let isRecFilled = false;
      if (recruiterConfig.common) {
        if (recruiterConfig.requiredRecruiter === "norecruiter") {
          isRecFilled = true;
        } else if (
          recruiterConfig.requiredRecruiter === "partrecruiter" &&
          recruiterConfig.panelist !== null &&
          assignedTo.length
        ) {
          isRecFilled = true;
        }
      } else {
        if (this.isCurrentRecFilled) {
          isRecFilled = true;
        }
      }
      let isVenFilled = false;
      if (vendorConfig.common) {
        if (vendor.length && this.isCommonVenFilled) {
          isVenFilled = true;
        } else if (!vendor.length) {
          isVenFilled = true;
        }
      } else {
        if (this.tempVendor.length || this.isCurrentVenFilled) {
          isVenFilled = true;
          if (this.tempVendor.length && this.$v.tempVendor.$invalid)
            isVenFilled = false;
        }
      }
      return isPanelFilled && isRecFilled && isVenFilled;
    },
    isCurrentRecFilled() {
      return this.currentRecuiterData.every(
        (rec) =>
          rec.recruiterData !== null &&
          rec.positionIDs.length &&
          rec.selectedPanels.length
      );
    },
    isPositionIDFilled() {
      return (
        this.isCreate &&
        this.currentRecuiterData.every((rec) => rec.positionIDs.length)
      );
    },
    isAllocateError() {
      if (!this.allocateData.vendorConfig.common) {
        if (this.tempVendor.length && this.$v.tempVendor.$error) return true;
        else if (!this.tempVendor.length && this.$v.currentVendorData.$error)
          return true;
      }
      if (this.commonVendorData.vendor.length) {
        const {
          taggedRecruiters,
          panelist,
          noOfCandidatesToPush,
          noOfRoundsToTake,
        } = this.$v.commonVendorData;
        let isError =
          taggedRecruiters.$error ||
          panelist.$error ||
          noOfRoundsToTake.$error ||
          !noOfCandidatesToPush.minValue ||
          noOfCandidatesToPush.$error;
        if (isError) return isError;
      }
      const { assignedPanelist, recruiterConfig, assignedTo } =
        this.$v.allocateData;
      if (
        assignedPanelist.$error ||
        recruiterConfig.panelist.$error ||
        assignedTo.$error
      ) {
        return true;
      }
      if (this.$v.currentRecuiterData.$error) {
        return true;
      }
      return false;
    },
    isCommonVenFilled() {
      const {
        vendor,
        taggedRecruiters,
        panelist,
        noOfCandidatesToPush,
        noOfRoundsToTake,
      } = this.commonVendorData;
      return (
        vendor.length > 0 &&
        taggedRecruiters.length > 0 &&
        ((noOfRoundsToTake === 0 && panelist === null) ||
          (noOfRoundsToTake !== null && panelist !== null)) &&
        noOfCandidatesToPush !== null
      );
    },
    isCurrentVenFilled() {
      const {
        vendor,
        noOfRoundsToTake,
        noOfCandidatesToPush,
        taggedRecruiters,
        panelist,
      } = this.currentVendorData;
      return (
        vendor !== null &&
        noOfRoundsToTake !== null &&
        noOfCandidatesToPush !== null &&
        taggedRecruiters !== null &&
        panelist !== null
      );
    },
    isIpError() {
      return (
        this.$v.interviewProcess.feedbackFormID.$error ||
        this.$v.interviewProcess.$error ||
        this.isAssessmentError ||
        this.isFaceToFaceError
      );
    },
    isAssessmentError() {
      const keys = this.$v.assessmentRounds.$each.$params;
      for (const key in keys) {
        const params = this.$v.assessmentRounds.$each[key].$params;
        for (const param in params) {
          if (this.$v.assessmentRounds.$each[key][param].$error) {
            return true;
          }
          if (!this.$v.assessmentRounds.$each[key].closeTestdt.isDateValid) {
            return true;
          }
        }
      }
      return false;
    },
    // THIS FUNCTION IS TO CHECK IF ANY OF THE MANDATORY FIELD IN FACE TO FACE IS HAVING ERROR
    // RIGHT NOW MANDATORY FIELD IS REMOVED FROM FACE TO FACE
    // USE THIS IF IN FUTURE ANY MANDATORY FIELD IS ADDED
    isFaceToFaceError() {
      const keys = this.$v.faceToFaceRounds.$each.$params;
      for (const key in keys) {
        const params = this.$v.faceToFaceRounds.$each[key].$params;
        for (const param in params) {
          if (this.$v.faceToFaceRounds.$each[key][param].$error) {
            return true;
          }
          if (!this.$v.faceToFaceRounds.$each[key].endDate.isDateValid) {
            return true;
          }
          if (
            !this.$v.faceToFaceRounds.$each[key].endDate
              .isEndDateAfterStartDatef2f
          ) {
            return true;
          }
          if (
            !this.$v.faceToFaceRounds.$each[key].startDate
              .isStartDateBeforeEndDatef2f
          ) {
            return true;
          }
        }
      }
      return false;
    },
    isIpFilled() {
      return (
        this.interviewProcess !== null &&
        Object.keys(this.interviewProcess).length &&
        this.isEachAsmntFilled
      );
    },
    isEachAsmntFilled() {
      if (this.assessmentRounds.length) {
        for (const index in this.assessmentRounds) {
          if (
            this.assessmentRounds[index].isEvalRequired &&
            !this.assessmentRounds[index].selevaluator.length
          ) {
            return false;
          }
          const keys = this.$v.assessmentRounds.$each[index].$params;
          for (const key in keys) {
            if (key === "selevaluator") {
              continue;
            }
            const model = this.$v.assessmentRounds.$each[index][key].$model;
            if (model === null || model.length === 0) {
              return false;
            }
          }
        }
      }
      return true;
    },
    // THIS FUNCTION IS TO CHECK IF ANY OF THE MANDATORY FIELD IN FACE TO FACE IS NOT PROVIDED
    // RIGHT NOW MANDATORY FIELD IS REMOVED FROM FACE TO FACE
    // USE THIS IF IN FUTURE ANY MANDATORY FIELD IS ADDED
    isEachFtfFilled() {
      if (this.faceToFaceRounds.length) {
        for (const index in this.faceToFaceRounds) {
          const keys = this.$v.faceToFaceRounds.$each[index].$params;
          for (const key of Object.keys(keys)) {
            const model = this.$v.faceToFaceRounds.$each[index][key].$model;
            if (model === null || model.length === 0) {
              return false;
            }
          }
        }
      }
      return true;
    },
    isPublishError() {
      return (
        this.$v.platformData.noOfInterviews.$error ||
        this.$v.platformData.threshold.$error ||
        this.$v.platformData.maxCheatingPercentage.$error ||
        this.interviewExceeded
      );
    },
    isPublishFilled() {
      if (this.platformData.automatic) return this.platformData.noOfInterviews;
      else return true;
    },
    interviewExceeded() {
      if (this.platformData.automatic) {
        return (
          (this.platformData.noOfInterviews - this.minIntrw) *
            this.costPerInterview >
          this.totalCredits
        );
      }
      return false;
    },
  },
  async mounted() {
    this.pageType = this.$route.query.type;
    this.getPanelIDs();
    this.shimmerLoader = true;
    // this.jobData.mailNotification = true;
    if (this.$route.query.to) {
      const tabName = this.$route.query.to;
      this.setActiveTab(tabName);
      if (tabName === "interview") {
        await this.getDataFromStore();
      } else {
        await this.getJobDetails();
      }
    } else if (this.$route.query.jobID) {
      await this.getJobDetails();
    } else {
      await this.initializeData("add");
      if (this.$route.params.parsedJD) {
        this.applyParsedJD(this.$route.params.parsedJD);
      }
      // this.jobData.openToPublic = true;
      // this.jobData.mailNotification = true;
    }
    if (this.isJdApproved) {
      this.getPositionStatusBar();
    }
    await this.getCreditsInfo();
    this.created = true;
  },
  methods: {
    async getCreditsInfo(jobStatus) {
      try {
        const res = await getCreditsInfo();
        if (res.status == 200) {
          this.totalCredits = res.data.data.data.availableCredits;
          this.costPerInterview = res.data.data.data.interviewCost;
          this.$forceUpdate();
          if (jobStatus == "refresh") {
            this.dynamicToast("success", "Credits fetched successfully.", "");
          } else if (jobStatus || jobStatus == 0) {
            console.log(this.interviewExceeded);
            if (this.interviewExceeded) {
              this.errorModal("Insufficent credits!");
            } else this.postJob(jobStatus);
          }
        } else if (jobStatus || jobStatus == 0) {
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        console.error(error);
        if (jobStatus || jobStatus == 0)
          this.errorModal("Something went wrong!");
      }
    },
    addPublishKeys() {
      let publishKeys = [
        "carrerPage",
        "linkedIn",
        "naukri",
        "automatic",
        "textNotification",
        "whatsAppNotification",
        "manualReview",
        "mailNotification",
        "threshold",
        "maxCheatingPercentage",
        "noOfInterviews",
        "meetingPlatform",
        "openToPublic",
      ];
      publishKeys.forEach((key) => {
        if (key in this.jobData) {
          this.platformData[key] = this.jobData[key];
          delete this.jobData[key];
        }
      });
      if (this.platformData.noOfInterviews && this.jobData.noOfInterviewsLeft) {
        this.minIntrw =
          parseInt(this.platformData.noOfInterviews) -
          parseInt(this.jobData.noOfInterviewsLeft);
      }
    },
    async reloadWindow() {
      await this.getJobDetails();
      this.setActiveTab("allocate");
    },
    toggleApplyToAll() {
      this.applyToAll = !this.applyToAll;
    },
    applyChangesToAll() {
      // Check if "Apply to all" is enabled and update all recruiters
      if (this.applyToAll) {
        const internalSelected =
          this.currentRecuiterData[0].selectedPanels.includes("internal");
        const externalSelected =
          this.currentRecuiterData[0].selectedPanels.includes("external");

        this.currentRecuiterData.forEach((recruiter) => {
          recruiter.selectedPanels = [];
          if (internalSelected) {
            recruiter.selectedPanels.push("internal");
          }
          if (externalSelected) {
            recruiter.selectedPanels.push("external");
          }
        });
      }
      // if (this.isJdApproved) {
      this.updateApplyToAll();
      // }
    },
    async updateApplyToAll() {
      try {
        this.updatePanelists();
        let assignedTo = [];
        this.currentRecuiterData.forEach((user) => {
          if (user.recruiterData !== null && user.positionIDs.length !== 0) {
            const internalSelected = user.selectedPanels.includes("internal");
            const externalSelected = user.selectedPanels.includes("external");
            if (internalSelected && externalSelected) {
              user.recruiterData.panelist = "both";
            } else if (internalSelected) {
              user.recruiterData.panelist = "internal";
            } else if (externalSelected) {
              user.recruiterData.panelist = "external";
            }
            assignedTo.push(user.recruiterData);
          }
        });
        if (this.isJdApproved) {
          let payload = {
            jobID: this.$route.query.jobID,
            assignedTo: assignedTo,
          };
          await updateApplyToAll(payload);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getPositionStatusBar() {
      try {
        let payload = {
          jobID: this.$route.query.jobID,
          chart: true,
        };
        let res = await getPositionIDStatus(payload);
        if (res.status === 200) {
          this.positionStatusBar = res.data.data;
          this.calculateStatusPercentages();
        }
      } catch (error) {
        console.error(error);
      }
    },
    calculateStatusPercentages() {
      const positionCount = this.positionStatusBar.positionCount;
      const positions = this.positionStatusBar.positions;

      // Initialize an array to hold the counts for each status (0 to 4)
      const statusCounts = new Array(5).fill(0);

      // Count the number of positions for each status
      positions.forEach((position) => {
        const status = position.status;
        if (status >= 0 && status <= 4) {
          statusCounts[status] += position.positionIDs.length;
        }
      });

      // Create the percentage array
      this.positionBarPercentage = statusCounts.map(
        (count) => ((count / positionCount) * 100).toFixed(2) + "%"
      );
    },
    onUpdateAssignedTo(data) {
      this.jobData.assignedTo = data.assignedTo;
      this.jobData.recruiterConfig = data.recruiterConfig;
      this.populateAllocate();
    },
    async writeWithHire3x(field) {
      this.showAILoader = true;
      this.$forceUpdate();
      if (this.jobData.title && this.jobData.skills.length) {
        try {
          const filteredJobData = { ...this.jobData };
          this.allocateKeys.forEach((key) => {
            delete filteredJobData[key];
          });
          if (filteredJobData.interviewProcess) {
            delete filteredJobData.interviewProcess;
          }
          filteredJobData.description = "";
          const formData = new FormData();
          formData.append("job", JSON.stringify(filteredJobData));
          const res = await aiJobDescription(formData);
          if (res.status === 200) {
            this.touchedFields[field.key] = true;
            this.setValue(field, res.data.description);
            this.showAILoader = false;
            this.$forceUpdate();
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    setJobTitleError(error, key) {
      if (error) {
        if (key === "title") {
          if (
            /^[a-zA-Z]/.test(this.jobData.title) &&
            this.isCreate &&
            this.isJobOpenings &&
            this.jobData.title !== "" &&
            this.savedOpeningsCount < this.jobData.openingsCount
          ) {
            this.oldOpeningsCount = this.savedOpeningsCount;
            if (this.savedOpeningsCount !== null) {
              this.savedOpeningsCount = parseInt(this.jobData.openingsCount);
            }
            if (!this.isOnlyHiringManager && !this.isHMLeadNotPreapproved) {
              this.generatePositionIds();
            }
          }
        } else if (key === "openingsCount") {
          if (
            /^[a-zA-Z]/.test(this.jobData.title) &&
            this.created &&
            this.isJobOpenings &&
            this.jobData.title !== "" &&
            this.savedOpeningsCount < this.jobData.openingsCount
          ) {
            this.oldOpeningsCount = this.savedOpeningsCount;
            if (this.savedOpeningsCount !== null) {
              this.savedOpeningsCount = parseInt(this.jobData.openingsCount);
            }
            if (!this.isOnlyHiringManager && !this.isHMLeadNotPreapproved) {
              this.generatePositionIds();
            }
          }
        }
      }
    },
    handleDeleteFeedback() {
      this.savedFeedback = null;
      this.feedbackFormID = "";
      this.$store.commit("jobDescriptionVUEX/saveFeedBackObject", {});
      this.interviewProcess.feedbackFormName = "";
      this.interviewProcess.feedbackFormID = "";
    },
    handleDeleteInterview() {
      this.interviewProcess = null;
      this.interviewProcessID = "";
      this.$store.commit("jobDescriptionVUEX/saveInterviewObject", {});
      this.$store.commit("jobDescriptionVUEX/saveAssesmentData", []);
    },
    deleteRecruiter(index) {
      this.currentRecuiterData.splice(index, 1);
    },
    async generatePositionIds() {
      try {
        const { openingsCount, title } = this.jobData;
        const positionsCount =
          this.oldOpeningsCount === null
            ? openingsCount
            : openingsCount - this.oldOpeningsCount;
        const payload = {
          noOfPositions: positionsCount,
          jobName: title,
          customerName: this.$route.query.customerName,
        };

        const res = await generatePositionIds(payload);
        if (res.status === 200) {
          const positionIDs = res.data.data.id;

          // Update recruiterConfig and positionIDs
          this.allocateData.recruiterConfig = {
            ...this.allocateData.recruiterConfig,
            positionIDs:
              this.oldOpeningsCount === null
                ? positionIDs
                : [
                    ...this.allocateData.recruiterConfig.positionIDs,
                    ...positionIDs,
                  ],
          };

          // Clear positionIDs for current recruiters if creating
          if (this.oldOpeningsCount === null && this.currentRecuiterData) {
            this.currentRecuiterData.forEach((recruiter) => {
              recruiter.positionIDs = [];
            });
          }

          const newPositions = positionIDs.map((id) => ({ id, count: 0 }));

          if (this.oldOpeningsCount === null) {
            this.positions = [];
            this.positions = newPositions;
          } else {
            // Concatenate existing positions with the new ones
            this.positions = [...this.positions, ...newPositions];
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    addRecruiter() {
      this.currentRecuiterData.forEach((rec) => {
        rec.showRecDropDown = false;
      });

      let selectedPanels;

      if (this.applyToAll) {
        const internalSelected =
          this.currentRecuiterData[0].selectedPanels.includes("internal");
        const externalSelected =
          this.currentRecuiterData[0].selectedPanels.includes("external");

        selectedPanels = [];
        if (internalSelected) selectedPanels.push("internal");
        if (externalSelected) selectedPanels.push("external");
      } else {
        selectedPanels =
          this.allocateData.requiredPanel === "nopanelist"
            ? ["external"]
            : ["internal"];
      }

      this.currentRecuiterData.unshift({
        panelist: null,
        recruiterData: null,
        selectedRecruiter: "",
        showRecDropDown: false,
        showPanelDropDown: false,
        selectedPanels: selectedPanels,
        positionIDs: [],
      });
    },
    addRecruiterAfterInterview() {
      if (this.currentRecuiterData.length) {
        const requiredKeys = [
          { key: "panelist", default: null },
          { key: "recruiterData", default: null },
          { key: "selectedRecruiter", default: "" },
          { key: "showRecDropDown", default: false },
          { key: "showPanelDropDown", default: false },
          {
            key: "selectedPanels",
            default:
              this.allocateData.requiredPanel === "nopanelist"
                ? ["external"]
                : ["internal"],
          },
          { key: "positionIDs", default: [] },
        ];

        this.currentRecuiterData.forEach((item) => {
          item.showRecDropDown = false;
          requiredKeys.forEach(({ key, default: defaultValue }) => {
            if (!(key in item)) {
              item[key] = defaultValue; // Add the missing key with its default value
            }
            if (item.recruiterData != null) {
              item.selectedRecruiter = item.recruiterData.userID;
            }
          });
        });
      }
    },
    compareJobDataHMandLead() {
      const keysToExclude = [
        "vendor",
        "vendorConfig",
        "userFolderIDs",
        "showAllPanelist",
        "assignedPanelist",
        "assignedTo",
        "status",
        "remarks",
        "startTime",
        "endTime",
        "recruiterConfig",
        "panelist",
        "interviewProcess",
        "activity",
        "approved",
        "userFolderIDs",
        "whatsAppNotification",
        "threshold",
        "maxCheatingPercentage",
        "textNotification",
        "mailNotification",
      ];
      const jobDetailCopy = this.excludeKeys(this.jobData, keysToExclude);
      const jobDetailCheckCopy = this.excludeKeys(
        this.jobDataCopy,
        keysToExclude
      );
      this.updateCheckHMandLead =
        JSON.stringify(jobDetailCopy) !== JSON.stringify(jobDetailCheckCopy);

      if (this.updateCheckHMandLead) {
        this.postJob("2");
      } else {
        if (this.jobData.status == "2") {
          this.postJob("2");
        } else {
          this.postJob("3");
        }
      }
    },
    compareJobData() {
      const keysToExclude = [
        "vendor",
        "vendorConfig",
        "userFolderIDs",
        "showAllPanelist",
        "assignedPanelist",
        "assignedTo",
        "status",
        "remarks",
        "startTime",
        "endTime",
        "recruiterConfig",
        "panelist",
        "openToPublic",
        "carrerPage",
        "linkedIn",
        "mailNotification",
        "textNotification",
        "whatsAppNotification",
        "threshold",
        "maxCheatingPercentage",
      ];
      const jobDetailCopy = this.excludeKeys(this.jobData, keysToExclude);
      const jobDetailCheckCopy = this.excludeKeys(
        this.jobDataCopy,
        keysToExclude
      );
      this.updateCheck =
        JSON.stringify(jobDetailCopy) !== JSON.stringify(jobDetailCheckCopy) ||
        JSON.stringify(this.assessmentRounds) !==
          JSON.stringify(this.assessmentRoundsCopy) ||
        JSON.stringify(this.faceToFaceRoundsCopy) !==
          JSON.stringify(this.faceToFaceRounds);
    },
    // Helper function to exclude specific keys from an object
    excludeKeys(obj, keys) {
      const copy = JSON.parse(JSON.stringify(obj));
      keys.forEach((key) => delete copy[key]);
      return copy;
    },
    buttonClickHandler() {
      if (
        (this.isOnlyLeadRecruiter || this.isHMLeadPreapproved) &&
        this.isPublish
      ) {
        this.saveAndApproveForm();
      } else if (this.isOnlyHiringManager || this.isHMLeadNotPreapproved) {
        this.saveAndApproveHiringManager();
      } else if (this.isBasic && this.roles.includes("EXTERNAL_ACCESS")) {
        if (this.updateCheck || this.currentStatus == "5") {
          this.saveAndApproveForm("2");
        } else {
          this.saveAndApproveForm(this.currentStatus);
        }
      } else if (this.isPublish) {
        if (this.isCreate || this.updateCheck || this.currentStatus == "5") {
          this.saveAndApproveForm("2");
        } else {
          this.saveAndApproveForm(this.currentStatus);
        }
      } else {
        this.setActiveTab(
          this.isBasic ? "interview" : this.isInterview ? "allocate" : "publish"
        );
      }
    },
    updateBasicError(value, key) {
      this.basicErrorMap[key] = value;
      for (const key in this.basicErrorMap) {
        if (this.basicErrorMap[key]) {
          this.isBasicError = true;
          this.$forceUpdate();
          return;
        }
      }
      this.isBasicError = false;
    },
    deleteTest(index) {
      const test =
        this.assessmentRounds[this.currentRoundIndex].selectedtests[index];
      const idIndex = this.assessmentRounds[
        this.currentRoundIndex
      ].testID.indexOf(test.testID);
      this.assessmentRounds[this.currentRoundIndex].selectedtests.splice(
        index,
        1
      );
      this.assessmentRounds[this.currentRoundIndex].testID.splice(idIndex, 1);
      if (this.assessmentRounds[this.currentRoundIndex].selectedtests.length) {
        this.checkForAutoEval(
          this.assessmentRounds[this.currentRoundIndex].testID,
          this.processMap[this.currentRoundID].index
        );
      } else {
        this.assessmentRounds[this.currentRoundIndex].isEvalRequired = false;
      }
    },
    async getPanelIDs() {
      try {
        const response = await getPanelIDs();
        if (response.status === 200) {
          this.panelIDs = response.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    updateErrorBasic(errorStatus) {
      this.basicError = errorStatus;
    },
    removePanel(userID) {
      let index = 0;
      while (index < this.allocateData.assignedPanelist.length) {
        if (this.allocateData.assignedPanelist[index].userID === userID) {
          const folderIndex = this.allocateData.userFolderIDs.Panelist.indexOf(
            this.allocateData.assignedPanelist[index].folderID
          );
          if (folderIndex !== -1) {
            this.allocateData.userFolderIDs.Panelist.splice(folderIndex, 1);
          }
          this.allocateData.assignedPanelist.splice(index, 1);
        } else {
          index++;
        }
      }
    },
    async getDataFromStore() {
      this.jobData = this.getJobData;
      if (!this.isCreate || this.isPositionIDFilled) {
        this.savedOpeningsCount = this.jobData.openingsCount;
      }

      if (this.$route.query.process) {
        this.interviewProcessID = this.$route.query.process;
        this.$store.commit("jobDescriptionVUEX/saveAssesmentData", []);
        await this.getParticularIP();
      } else if (this.$route.query.processName) {
        this.$store.commit("jobDescriptionVUEX/saveFeedBackObject", {
          feedbackFormID: this.$route.query.fbprocess,
          name: this.$route.query.processName,
        });
      }
      if (
        this.getSavedInterview != null &&
        Object.keys(this.getSavedInterview).length
      ) {
        this.populateIpData(this.getSavedInterview);
        if (this.getAssesmentData.length) {
          this.assessmentRounds = this.getAssesmentData;
        }
        this.$store.commit("jobDescriptionVUEX/saveInterviewObject", {});
        this.$store.commit("jobDescriptionVUEX/saveAssesmentData", []);
      }
      if (
        this.getSavedFeedBack != null &&
        Object.keys(this.getSavedFeedBack).length
      ) {
        this.populateFeedbackData(this.getSavedFeedBack);
        this.$store.commit("jobDescriptionVUEX/saveFeedBackObject", {});
      }
      this.addPublishKeys();
      this.populateAllocate();
      this.jobDataCopy = JSON.parse(JSON.stringify(this.jobData));
      await this.initializeData("edit");
      this.checkBasicFilled();
    },
    async getParticularIP() {
      try {
        let payload = {
          interviewProcessID: this.interviewProcessID,
        };
        let res = await getintprocess(payload);
        this.interviewProcess = res.data.data;
        if (
          this.interviewProcess !== null &&
          Object.keys(this.interviewProcess).length
        ) {
          this.$store.commit(
            "jobDescriptionVUEX/saveInterviewObject",
            this.interviewProcess
          );
        }
      } catch (error) {
        console.error(error);
      }
    },
    goBack() {
      const { itype, isort, wtype, wsort, gridView } = this.$route.query;
      this.$router.push({
        name: "InternalHiringDashboard",
        params: {
          cardName: this.getCustomerDetail.name,
          customerID: this.getCustomerDetail.customerID,
        },
        query: {
          cardName: this.getCustomerDetail.name,
          itype,
          isort,
          wtype,
          wsort,
          gridView,
        },
      });
    },
    updateValidations(field) {
      if (field.fieldType == "default") {
        this.validations[field.key].required = field.mandatory;
      } else {
        this.validations["customFields"][field.key].required = field.mandatory;
      }
      this.$forceUpdate();
    },
    // Fills the new job with the values read from an uploaded JD file.
    applyParsedJD(parsedJD) {
      this.customFields.forEach((field) => {
        const value = parsedJD[field.key];
        // Not found in the JD (null, or an empty list for list fields): keep
        // the form's own value, e.g. a multi-select's default options. The
        // form is always new here, so there is nothing else to clear.
        if (value === null || value === undefined) return;
        if (Array.isArray(value) && !value.length) return;
        const target =
          field.fieldType === "default"
            ? this.jobData
            : this.jobData.customFields;
        if (typeof target[field.key] === typeof value) {
          this.$set(target, field.key, value);
        }
      });
      // Check the filled form now (as Next/Save does, without the pop-up), so
      // values that break a rule and mandatory fields the JD couldn't fill -
      // including ones revealed by a filled value, like "Other role" - show
      // their errors straight away. Optional empty fields show nothing.
      this.customFields.forEach((field) => this.setTouchValue(field.key));
      this.$forceUpdate();
    },
    async initializeData(type) {
      const response = await getCustomFields("1", type);
      if (response.length) {
        if (type === "add") {
          [this.customFields, this.jobData, this.touchedFields] = response;
        } else {
          [this.customFields, this.touchedFields] = response;
        }
        this.customFields.forEach((obj) => {
          if (obj.category === 1 || obj.category === null) {
            this.basicArray.push(obj); // Push objects with category value 1 into category1Array
          } else if (obj.category === 2) {
            this.advanceArray.push(obj); // Push objects with category value 2 into category2Array
          }
        });
        this.validations = dynamicRules(this.customFields);
        if (type == "edit") {
          var found = false;
          for (var i = 0; i < this.basicArray.length; i++) {
            if (
              (this.basicArray[i].key == "source" &&
                this.jobData[this.basicArray[i].key] === "other") ||
              (this.basicArray[i].key == "experienceRequired" &&
                this.jobData.customFields[this.basicArray[i].key] ===
                  "12+ years")
            ) {
              var seqId = this.basicArray[i].seq;
              for (var j = 0; j < this.basicArray.length; j++) {
                if (
                  this.basicArray[j].seq === seqId &&
                  this.basicArray[j].hide === true
                ) {
                  this.basicArray[j].hide = false;
                  this.updateValidations(this.basicArray[j]);
                  found = true;
                  break; // No need to continue once updated
                }
              }
              if (found) {
                break; // No need to continue searching once updated
              }
            }
            if (
              this.basicArray[i].key == "documents" &&
              this.jobData[this.basicArray[i].key] == true
            ) {
              var docSeqId = this.basicArray[i].seq;
              for (var m = 0; m < this.basicArray.length; m++) {
                if (
                  this.basicArray[m].seq === docSeqId &&
                  this.basicArray[m].hide === true
                ) {
                  this.basicArray[m].hide = false;
                  this.updateValidations(this.basicArray[m]);
                  found = true;
                  break; // No need to continue once updated
                }
              }
              if (found) {
                break; // No need to continue searching once updated
              }
            }
          }
          for (var k = 0; k < this.advanceArray.length; k++) {
            if (
              (this.advanceArray[k].key == "noticePeriod" &&
                this.jobData[this.advanceArray[k].key] === "other") ||
              (this.advanceArray[k].key == "experienceRequired" &&
                this.jobData.customFields[this.advanceArray[k].key] ===
                  "12+ years")
            ) {
              var advanceSeqId = this.advanceArray[k].seq;
              for (var l = 0; l < this.advanceArray.length; l++) {
                if (
                  this.advanceArray[l].seq === advanceSeqId &&
                  this.advanceArray[l].hide === true
                ) {
                  this.advanceArray[l].hide = false;
                  this.updateValidations(this.advanceArray[l]);
                  found = true;
                  break; // No need to continue once updated
                }
              }
              if (found) {
                break; // No need to continue searching once updated
              }
            }
          }
        }
        this.shimmerLoader = false;
      } else {
        console.error("Something went wrong");
      }
    },
    async getJobDetails() {
      try {
        let payload = {
          type: "2",
          jobID: this.$route.query.jobID,
          lead: this.getCustomerDetail.lead,
        };
        const response = await getJobByID(payload);
        if (response.status === 200) {
          this.jobData = response.data.data;
          if (!this.isCreate || this.isPositionIDFilled) {
            this.savedOpeningsCount = this.jobData.openingsCount;
          }
          this.addPublishKeys();
          this.jobDataCopy = JSON.parse(JSON.stringify(this.jobData));
          this.currentStatus = this.jobData.status;
          if (
            (this.isOnlyHiringManager || this.isHMLeadNotPreapproved) &&
            !this.isCreate
          ) {
            this.allocateData.recruiterConfig = this.jobData.recruiterConfig;
          }
          if (!this.isOnlyHiringManager && !this.isHMLeadNotPreapproved) {
            this.interviewProcess = this.jobData.interviewProcess;
            if (
              this.interviewProcess !== null &&
              Object.keys(this.interviewProcess).length
            ) {
              this.populateIpData();
              this.populateFeedbackData();
            }
            this.populateAllocate();
          }
          this.jobDataCopy = JSON.parse(JSON.stringify(this.jobData));
          await this.initializeData("edit");
          this.checkForOtherRole();
          this.checkBasicFilled();
          if (this.pageType !== "Create") {
            this.isSaveAndApprove = true;
            this.isOnlyLeadRecruiter ? "" : this.validateForm();
          } else {
            this.$v.interviewProcess.$touch();
            this.$v.interviewProcess.feedbackFormID.$touch();
            this.$v.assessmentRounds.$touch();
            this.$v.faceToFaceRounds.$touch();
          }
          this.$forceUpdate();
        }
      } catch (error) {
        console.error(error);
      }
    },
    checkForOtherRole() {
      for (const field of this.basicArray) {
        if (field.key === "role" && this.jobData[field.key] === "others") {
          const seqID = field.seq;
          for (const field1 of this.basicArray) {
            if (field1.seq === seqID && field1.hide) {
              field1.hide = false;
              this.updateValidations(field1);
              field1.mandatory = true;
              return;
            }
          }
        }
      }
    },
    populateAllocate() {
      for (const key of this.allocateKeys) {
        this.allocateData[key] = this.jobData[key];
      }
      if (this.allocateData.assignedPanelist.length) {
        this.allocateData.requiredPanel = "partpanelist";
      } else if (!this.allocateData.showAllPanelist) {
        this.allocateData.requiredPanel = "nopanelist";
      }
      if (
        this.allocateData.recruiterConfig.positionIDs &&
        this.allocateData.recruiterConfig.positionIDs.length
      ) {
        // Create positions based on allocated data
        this.positions = this.allocateData.recruiterConfig.positionIDs.map(
          (id) => ({
            id: id,
            count: 0,
          })
        );
      }
      if (this.allocateData.assignedTo.length) {
        if (this.allocateData.recruiterConfig.common) {
          this.allocateData.recruiterConfig.requiredRecruiter = "partrecruiter";
        } else {
          this.initializeRecruiterData();
        }
      }

      // Prepare a set of userIDs from assignedTo for efficient lookup
      const assignedUserIDs = new Set(
        this.allocateData.assignedTo.map((user) => user.userID)
      );

      // Include this.roleValues.userID in the set
      if (this.roleValues && this.roleValues.userID) {
        assignedUserIDs.add(this.roleValues.userID);
      }

      if (
        this.allocateData.vendorConfig.common &&
        this.allocateData.vendor.length
      ) {
        const vendorData = this.allocateData.vendor[0];
        this.commonVendorData.taggedRecruiters =
          vendorData.taggedRecruiters.filter((userID) =>
            assignedUserIDs.has(userID)
          );
        this.commonVendorData.panelist = vendorData.panelist;
        this.commonVendorData.noOfCandidatesToPush =
          vendorData.noOfCandidatesToPush;
        this.commonVendorData.noOfRoundsToTake = vendorData.noOfRoundsToTake;
        this.allocateData.vendor.forEach((vendor) => {
          delete vendor.taggedRecruiters;
          delete vendor.panelist;
          delete vendor.noOfCandidatesToPush;
          delete vendor.noOfRoundsToTake;
          this.commonVendorData.vendor.push(vendor);
        });
      } else if (!this.allocateData.vendorConfig.common) {
        this.allocateData.vendor.forEach((vendor) => {
          // Filter taggedRecruiters for this vendor
          let filteredTaggedRecruiters = vendor.taggedRecruiters?.filter(
            (userID) => assignedUserIDs.has(userID)
          );

          let vendorData = {
            noOfRoundsToTake: vendor.noOfRoundsToTake,
            noOfCandidatesToPush: vendor.noOfCandidatesToPush,
            taggedRecruiters: filteredTaggedRecruiters,
            panelist: vendor.panelist,
          };
          delete vendor.noOfRoundsToTake;
          delete vendor.noOfCandidatesToPush;
          delete vendor.taggedRecruiters;
          delete vendor.panelist;
          this.tempVendor.push({
            ...vendorData,
            vendor: { ...vendor },
            showVendor: false,
            showRounds: false,
            showRec: false,
            showPanel: false,
          });
        });
      }
    },

    updateCounts() {
      // Iterate through currentRecuiterData to update counts
      this.currentRecuiterData.forEach((recruiter) => {
        recruiter.positionIDs.forEach((posID) => {
          const position = this.positions.find((pos) => pos.id === posID);
          if (position) {
            position.count += 1;
          }
        });
      });
    },

    initializeRecruiterData() {
      this.populateRecruiterData();
      // Update counts after initializing recruiters
      this.updateCounts();
    },
    populateRecruiterData() {
      this.currentRecuiterData = [];

      this.allocateData.assignedTo.forEach((user) => {
        let recruiterEntry = {
          panelist: user.panelist,
          recruiterData: user,
          selectedRecruiter: user.userID,
          showRecDropDown: false,
          positionIDs: user.positionIDs || [],
          selectedPanels: [],
        };

        // Determine selected panels
        if (user.panelist === "internal") {
          recruiterEntry.selectedPanels.push("internal");
        } else if (user.panelist === "external") {
          recruiterEntry.selectedPanels.push("external");
        } else {
          recruiterEntry.selectedPanels.push("internal", "external");
        }

        this.currentRecuiterData.push(recruiterEntry);
      });
    },
    populateFeedbackData(feedback = null) {
      if (feedback) {
        this.savedFeedback = {
          feedbackFormID: feedback.feedbackFormID,
          name: feedback.name,
        };
      } else if (this.jobData.interviewProcess.feedbackFormID) {
        this.savedFeedback = {
          feedbackFormID: this.jobData.interviewProcess.feedbackFormID,
          name: this.jobData.interviewProcess.feedbackFormName,
        };
      }
      if (
        this.savedFeedback != null &&
        Object.keys(this.savedFeedback).length > 0
      ) {
        this.feedbackFormID = this.savedFeedback.feedbackFormID;
      }
    },
    populateIpData(interview = null) {
      let assessmentIndex = 0;
      let f2fIndex = 0;
      this.assessmentRounds = [];
      this.faceToFaceRounds = [];
      this.processMap = {};
      if (interview) {
        this.interviewProcess = interview;
      } else if (this.jobData.interviewProcess) {
        this.interviewProcess = this.jobData.interviewProcess;
      }
      this.currentRoundID = this.interviewProcess.process[1].id;
      this.interviewProcessID = this.interviewProcess.interviewProcessID;
      this.interviewProcess.process.forEach((process, processIndex) => {
        if (process.type === "assesment") {
          if (interview) {
            process = this.addAssessmentMetaData(process);
          }
          this.assessmentRounds.push(process);
          this.processMap[process.id] = {
            index: assessmentIndex++,
            type: "assessment",
            key: "assessments",
            actualIndex: processIndex,
            isFilled: false,
          };
          if (process.selectedtests.length) {
            this.checkForAutoEval(process.testID, assessmentIndex - 1);
          } else {
            this.assessmentRounds[assessmentIndex - 1].isEvalRequired = false;
          }
          if (process.closeTestdt)
            process.closeTestdt = convertTime(process.closeTestdt, "india");
          if (process.openTestdt)
            process.openTestdt = convertTime(process.openTestdt, "india");
        } else if (process.type === "f2f") {
          if (interview) {
            process = this.addFaceToFaceMetaData(process);
          }
          this.faceToFaceRounds.push(process);
          this.processMap[process.id] = {
            actualIndex: processIndex,
            index: f2fIndex++,
            type: "faceToFace",
            key: "faceToFace",
            isFilled: false,
          };
        }
        this.$v.assessmentRounds.$reset();
        this.$v.faceToFaceRounds.$reset();
        this.assessmentRoundsCopy = JSON.parse(
          JSON.stringify(this.assessmentRounds)
        );
        this.faceToFaceRoundsCopy = JSON.parse(
          JSON.stringify(this.faceToFaceRounds)
        );
        if (interview) this.interviewProcess.process[processIndex] = process;
        this.clearFullVendor();
      });
    },
    addAssessmentMetaData(process) {
      process = {
        ...process,
        sentAutomatically: false,
        passingPercentage: "",
        showJDToPanel: false,
        selectedtests: [],
        selevaluator: [],
        testID: [],
        config: {},
        configName: null,
        jdDetailsType: 0,
        configID: null,
        isEvalRequired: false,
      };
      return process;
    },
    addFaceToFaceMetaData(process) {
      delete process.testID;
      process.showJDToPanel = false;
      process.jdDetailsType = 0;
      return process;
    },
    clearFullVendor() {
      this.allocateData.vendorConfig.common = true;
      this.allocateData.vendor = [];
      this.tempVendor = [];
      this.commonVendorData = {
        vendor: [],
        taggedRecruiters: [],
        panelist: null,
        noOfCandidatesToPush: null,
        noOfRoundsToTake: null,
      };
      this.currentVendorData = {
        vendor: null,
        noOfRoundsToTake: null,
        noOfCandidatesToPush: null,
        taggedRecruiters: [],
        panelist: null,
        showVendor: false,
        showRounds: false,
        showRec: false,
        showPanel: false,
      };
      this.$v.currentVendorData.$reset();
      this.$v.commonVendorData.$reset();
      this.$v.tempVendor.$reset();
      this.$forceUpdate();
    },
    clearVendor() {
      this.currentVendorData = {
        vendor: null,
        noOfRoundsToTake: null,
        noOfCandidatesToPush: null,
        taggedRecruiters: [],
        panelist: null,
        showVendor: false,
        showRounds: false,
        showRec: false,
        showPanel: false,
      };
    },
    removeVendor(index) {
      this.commonVendorData.vendor.splice(index, 1);
    },
    ...mapMutations("jobDescriptionVUEX", {
      saveJobData: "saveJobData",
    }),
    switchToIP(type) {
      if (this.isIpSelected) {
        this.$store.commit(
          "jobDescriptionVUEX/saveInterviewObject",
          this.interviewProcess
        );
        this.$store.commit(
          "jobDescriptionVUEX/saveAssesmentData",
          this.assessmentRounds
        );
      }
      if (
        this.savedFeedback != null &&
        Object.keys(this.savedFeedback).length
      ) {
        this.$store.commit(
          "jobDescriptionVUEX/saveFeedBackObject",
          this.savedFeedback
        );
      }
      switch (type) {
        case "interviewProcess":
          this.interviewProcess = null;
          this.interviewProcessID = "";
          this.assessmentRounds = [];
          this.faceToFaceRounds = [];
          break;
        case "feedbackForm":
          this.savedFeedback = null;
          this.feedbackFormID = null;
          break;
      }
      this.generatePayload();
      this.saveJobData({
        ...this.platformData,
        ...this.jobData,
        ...this.allocateData,
      });
      const { wtype, wsort, itype, isort, customerName } = this.$route.query;
      this.$router.push({
        name: "HiringProcessDashboard",
        query: {
          status: type == "feedbackForm" ? "feedbackForm" : "interviewProcess",
          redirectTo: "CreateJob",
          type: this.$route.query.wtype,
          sort: this.$route.query.wsort,
          key: "fromJD",
          pageType: this.pageType,
          ...(!this.isCreate ? { jobID: this.$route.query.jobID } : {}),
          wtype,
          wsort,
          itype,
          isort,
          customerName,
        },
      });
    },
    saveConfigData(roundData, index) {
      this.assessmentRounds[index] = {
        ...this.assessmentRounds[index],
        configID: roundData.configID,
        configName: roundData.configName,
      };
      this.$v.assessmentRounds.$each[index].configID.$model =
        roundData.configID;
    },
    saveTests(tests, testIDs) {
      this.assessmentRounds[this.currentRoundIndex].selectedtests = tests;
      this.assessmentRounds[this.currentRoundIndex].testID = testIDs;
      this.checkForAutoEval(
        testIDs,
        this.processMap[this.currentRoundID].index
      );
    },
    async checkForAutoEval(testID, index) {
      try {
        const response = await checkTestAutocorrected({ testID });
        const autoCorrect = response.data.data.Detail.testAutocorrect;
        this.assessmentRounds[index].isEvalRequired = !autoCorrect;
      } catch (error) {
        console.error(error);
      }
    },
    setTouchValue(key) {
      this.touchedFields[key] = true;
    },
    setActiveTab(tab) {
      this.currentTab = tab;
    },
    setValue({ fieldType, key, category, seq }, value) {
      if (fieldType == "default") {
        this.jobData[key] = value;
      } else {
        this.jobData.customFields[key] = value;
      }
      if (key === "role" || key === "experienceRequired") {
        let keyValue = key === "role" ? "otherRole" : "minExperienceRequired";
        if (category === 1 || category === null) {
          const selectedIndex = this.basicArray.findIndex((option) => {
            return option.seq === seq && option.key === keyValue;
          });

          if (
            (key === "role" && value === "others") ||
            (key === "experienceRequired" && value === "12+ years")
          ) {
            this.basicArray[selectedIndex].hide = false;
            this.basicArray[selectedIndex].mandatory = true;
            this.updateValidations(this.basicArray[selectedIndex]);
          } else {
            this.jobData[keyValue] = "";
            this.basicArray[selectedIndex].hide = true;
            this.basicArray[selectedIndex].mandatory = false;
            this.updateValidations(this.basicArray[selectedIndex]);
          }
        } else if (category === 2 && key === "experienceRequired") {
          const selectedIndex = this.advanceArray.findIndex((option) => {
            return option.seq === seq && option.key === "minExperienceRequired";
          });
          if (value === "12+ years") {
            this.advanceArray[selectedIndex].hide = false;
            this.advanceArray[selectedIndex].mandatory = true;
            this.updateValidations(this.advanceArray[selectedIndex]);
          } else {
            this.jobData[keyValue] = "";
            this.advanceArray[selectedIndex].hide = true;
            this.advanceArray[selectedIndex].mandatory = false;
            this.updateValidations(this.advanceArray[selectedIndex]);
          }
        } else {
          const selectedIndex = this.advanceArray.findIndex(
            (option) => option.seq === seq && option.hide
          );
          this.advanceArray[selectedIndex].hide = false;
          this.advanceArray[selectedIndex].mandatory = true;
          this.updateValidations(this.advanceArray[selectedIndex]);
        }
      }
      if (key == "documents") {
        if (category === 1 || category === null) {
          const selectedIndex = this.basicArray.findIndex((option) => {
            return option.seq === seq && option.key === "requiredDocumets";
          });
          if (value === true) {
            this.basicArray[selectedIndex].hide = false;
            this.basicArray[selectedIndex].mandatory = true;
            this.updateValidations(this.basicArray[selectedIndex]);
          } else {
            this.jobData["requiredDocumets"] = [];
            this.basicArray[selectedIndex].hide = true;
            this.basicArray[selectedIndex].mandatory = false;
            this.updateValidations(this.basicArray[selectedIndex]);
          }
        } else {
          const selectedIndex = this.advanceArray.findIndex(
            (option) => option.seq === seq && option.hide
          );
          this.advanceArray[selectedIndex].hide = false;
          this.advanceArray[selectedIndex].mandatory = true;
          this.updateValidations(this.advanceArray[selectedIndex]);
        }
      }

      this.checkBasicFilled();
      this.$forceUpdate();
    },
    checkBasicFilled() {
      let isFilled = true;
      for (const field of this.customFields) {
        if (field.controlType == "boolean") continue;
        if (field.fieldType == "default") {
          if (
            (this.jobData[field.key] == null ||
              this.jobData[field.key].length == 0) &&
            field.mandatory
          ) {
            isFilled = false;
          }
        } else {
          if (
            (this.jobData.customFields[field.key] == null ||
              this.jobData.customFields[field.key].length == 0) &&
            field.mandatory
          ) {
            isFilled = false;
          }
        }
        if (!isFilled) break;
      }
      this.isBasicFilled = isFilled;
    },
    titleCheck() {
      this.isSaveAndApprove = false;
      for (const key in this.touchedFields) {
        this.touchedFields[key] = false;
      }
      this.$v.currentRecuiterData.$reset();
      if (this.jobData.title === "") {
        this.touchedFields.title = true;
        this.errorModal("Please provide title");
        return;
      }

      if (!/^[a-zA-Z]/.test(this.jobData.title)) {
        this.touchedFields.title = true;
        this.errorModal("Please provide valid title");
        return;
      }
      if (this.savedOpeningsCount > this.jobData.openingsCount) {
        this.touchedFields.openingsCount = true;
        this.errorModal("Please provide valid openings count");
        return;
      }
      this.setFeedbackForm();
      this.updatePanelists();
      this.removeUnnecessaryPanelists();
      const status = this.isCreate ? "1" : "5";
      this.postJob(status, "fromsave");
    },
    async postJob(jobStatus, from) {
      this.buttonLoader = true;
      this.finalStatus = JSON.parse(JSON.stringify(this.buttonLabel));
      let jobClone = JSON.parse(JSON.stringify(this.jobData));
      for (const field of this.customFields) {
        if (
          field.controlType === "upload_file" &&
          (this.isCreate || field.isReupload)
        ) {
          if (field.fieldType === "default") {
            delete jobClone[field.key];
          } else {
            delete jobClone.customFields[field.key];
          }
        }
      }
      let payload = {
        ...jobClone,
        ...this.platformData,
        customerID: this.getCustomerDetail.customerID,
      };
      if (!payload.automatic) payload.noOfInterviews = null;
      payload.threshold =
        this.platformData.threshold != null && this.platformData.threshold != ""
          ? this.platformData.threshold
          : 0;
      payload.maxCheatingPercentage = !this.assessIntProcess
        ? null
        : this.platformData.maxCheatingPercentage != null &&
          this.platformData.maxCheatingPercentage != ""
        ? this.platformData.maxCheatingPercentage
        : 0;
      this.generatePayload();
      payload.interviewProcess = { ...this.interviewProcess };
      let res;
      if (!this.isOnlyHiringManager && !this.isHMLeadNotPreapproved) {
        this.generatePayload();
        payload.interviewProcess = { ...this.interviewProcess };
        if (payload.interviewProcess.process) {
          res = await this.checkAndUpdateConfig(
            payload.interviewProcess.process
          );
          payload.interviewProcess.process = this.checkAndConvertTime(
            payload.interviewProcess.process,
            "utc"
          );
        }
      }
      if (
        res ||
        from ||
        this.isOnlyHiringManager ||
        this.isHMLeadNotPreapproved ||
        (!this.updateCheckHMandLead && this.isHMLeadPreapproved)
      ) {
        if (!this.isOnlyHiringManager && !this.isHMLeadNotPreapproved) {
          payload = {
            ...payload,
            ...this.allocateData,
            status: jobStatus,
            ...(this.isActiveOrOpen ? { active: true, closed: false } : {}),
            remarks: "",
          };
          delete payload.requiredPanel;
        } else if (this.isOnlyHiringManager || this.isHMLeadNotPreapproved) {
          payload = {
            ...payload,
            status: jobStatus,
          };
        }
        if (!payload.assignedTo) payload.assignedTo = [];
        else if (payload.assignedTo.length != 0) {
          payload.assignedTo = payload.assignedTo.filter(
            (obj) => "email" in obj
          );
        }
        if (payload.customFields.experienceRequired !== "12+ years")
          payload.customFields.minExperienceRequired = null;
        try {
          let response = await createJob(payload);
          if (response.status === 200) {
            const jobID = response.data.data.Detail;
            const form = new FormData();
            form.append("type", "1");
            form.append("jobID", jobID);
            const attachment = [];
            for (const field of this.customFields) {
              const key =
                field.fieldType === "default"
                  ? this.jobData[field.key]
                  : this.jobData.customFields[field.key];
              if (
                field.controlType === "upload_file" &&
                (this.isCreate || field.isReupload) &&
                key
              ) {
                let obj = {
                  attachmentName: field.key,
                };
                attachment.push(obj);
                form.append(field.key, key);
              }
            }
            form.append("attachment", JSON.stringify(attachment));
            if (attachment.length) {
              await uploadDocumentAPI(form);
            }
            let type = "success",
              title,
              message;
            switch (this.pageType) {
              case "Create":
                if (jobStatus !== "1" && jobStatus !== "5") {
                  type = "approve";
                  title = "Sent for approval";
                  message =
                    this.jobData.title + " job has been sent for approval.";
                } else {
                  title = "Successfully saved";
                  message = this.jobData.title + " job has been saved.";
                }
                break;
              case "Edit":
                if (jobStatus !== "1" && jobStatus !== "5") {
                  title = "Successfully updated";
                  if (
                    jobStatus == 2 &&
                    this.finalStatus == "Update and Send for Approval"
                  )
                    message =
                      this.jobData.title +
                      " job has been updated and sent for approval.";
                  else message = this.jobData.title + " job has been updated.";
                } else {
                  title = "Successfully saved";
                  message = this.jobData.title + " job has been saved.";
                }
                break;
              case "Activate":
                title = "Successfully activated";
                message = this.jobData.title + " job has been activated.";
                break;
              case "Re-Open":
                title = "Successfully re-opened";
                message = this.jobData.title + " job has been re-opened.";
                break;
            }
            this.dynamicToast(type, title, message);
            this.goBack();
          } else if (response.status === 208) {
            this.errorModal("Job name already exists");
            this.buttonLoader = false;
            if (!this.isOnlyHiringManager && !this.isHMLeadNotPreapproved) {
              this.populateRecruiterData();
              if (
                this.interviewProcess?.process &&
                this.interviewProcess.process.length != 0
              ) {
                this.interviewProcess.process = this.checkAndConvertTime(
                  this.interviewProcess.process,
                  "india"
                );
              }
            }
          } else {
            this.buttonLoader = false;
            this.errorModal("Something went wrong!");
          }
        } catch (error) {
          console.error(error);
          this.buttonLoader = false;
          this.errorModal("Something went wrong!");
        }
      } else {
        this.buttonLoader = false;
        let msg = res.data?.data?.Detail
          ? res.data.data.Detail
          : "Something went wrong!";
        this.errorModal(msg);
      }
    },
    setFeedbackForm() {
      if (this.feedbackFormID && this.isIpSelected) {
        const invalidRounds = [0, "F", "R", "NI", "H"];
        const feedbackFormID = this.feedbackFormID;
        this.interviewProcess.feedbackFormID = feedbackFormID;
        this.interviewProcess.process.forEach((process) => {
          if (!invalidRounds.includes(process.id)) {
            delete process.feedbackFormID;
            delete process.feedbackform;
            process.feedbackFormID = feedbackFormID;
          }
        });
      }
    },
    generatePayload() {
      if (
        this.interviewProcess !== null &&
        Object.keys(this.interviewProcess).length
      ) {
        this.addInterviewData();
      }
      if (this.allocateData.assignedPanelist.length) {
        this.allocateData.assignedPanelist.forEach((panel, index) => {
          this.allocateData.assignedPanelist[index] = {
            ...panel,
            panelID: this.panelIDs[panel.userID]
              ? this.panelIDs[panel.userID]
              : null,
          };
        });
      }
      if (
        this.allocateData.recruiterConfig.common &&
        this.allocateData.assignedTo.length &&
        this.allocateData.requiredRecruiter === "partrecruiter"
      ) {
        this.allocateData.assignedTo.forEach(
          (user) => (user.panelist = this.allocateData.recruiterConfig.panelist)
        );
      } else if (!this.allocateData.recruiterConfig.common) {
        this.allocateData.assignedTo = [];
        this.currentRecuiterData.forEach((data) => {
          this.allocateData.assignedTo.push({
            ...data.recruiterData,
            positionIDs: data.positionIDs,
            panelist: data.panelist,
          });
          delete data.showPanelDropDown;
          delete data.showRecDropDown;
          delete data.selectedPanels;
          delete data.selectedRecruiter;
        });
      }
      if (
        this.allocateData.vendorConfig.common &&
        this.commonVendorData.vendor.length
      ) {
        this.allocateData.vendor = [];
        this.commonVendorData.vendor.forEach((vendor) => {
          this.allocateData.vendor.push({
            ...vendor,
            taggedRecruiters: this.commonVendorData.taggedRecruiters,
            panelist: this.commonVendorData.panelist,
            noOfCandidatesToPush: parseInt(
              this.commonVendorData.noOfCandidatesToPush
            ),
            noOfRoundsToTake: this.commonVendorData.noOfRoundsToTake,
          });
        });
      } else {
        this.allocateData.vendor = [];
        if (
          this.currentVendorData.noOfRoundsToTake === 0 ||
          this.isCurrentVenFilled
        ) {
          this.allocateData.vendor.push({
            ...this.currentVendorData.vendor,
            taggedRecruiters: this.currentVendorData.taggedRecruiters,
            panelist: this.currentVendorData.panelist,
            noOfCandidatesToPush: parseInt(
              this.currentVendorData.noOfCandidatesToPush
            ),
            noOfRoundsToTake: this.currentVendorData.noOfRoundsToTake,
          });
        }
        this.tempVendor.forEach((vendor) => {
          this.allocateData.vendor.push({
            ...vendor.vendor,
            taggedRecruiters: vendor.taggedRecruiters,
            noOfRoundsToTake: vendor.noOfRoundsToTake,
            noOfCandidatesToPush: parseInt(vendor.noOfCandidatesToPush),
            panelist: vendor.panelist,
          });
        });
      }
    },
    addInterviewData() {
      this.interviewProcess.process.forEach((process, index) => {
        if (this.checkValidRound(process.id)) {
          if (process.type === "assesment") {
            this.interviewProcess.process[index] =
              this.assessmentRounds[this.processMap[process.id].index];
          } else {
            this.interviewProcess.process[index] =
              this.faceToFaceRounds[this.processMap[process.id].index];
          }
        }
      });
    },
    validateForm() {
      let invalidForm = false;
      for (let i = 0; i < this.customFields.length; i++) {
        const field = this.customFields[i];
        this.setTouchValue(field.key);
        this.$forceUpdate();
        if (
          !validateField(field, {
            newObject: this.jobData,
            validations: this.validations,
            valText: {},
          })
        ) {
          invalidForm = true;
        }
        if (
          !/^[a-zA-Z]/.test(this.jobData.title) ||
          this.savedOpeningsCount > this.jobData.openingsCount
        ) {
          invalidForm = true;
        }
      }
      return invalidForm;
    },
    async saveAndApproveHiringManager() {
      this.isBasicError = this.validateForm();
      if (!this.isBasicError) {
        if (this.jobData.openingsCount != this.jobDataCopy.openingsCount) {
          await this.generatePositionIds();
        }
        if (this.allocateData && this.allocateData.recruiterConfig) {
          this.jobData = {
            ...this.jobData,
            recruiterConfig: this.allocateData.recruiterConfig,
          };
        }
        this.postJob("2");
      } else {
        this.errorModal("Please fill all fields");
      }
    },
    saveAndApproveForm(jobStatus) {
      this.isSaveAndApprove = true;
      const isBasicInvalid = this.isOnlyLeadRecruiter
        ? false
        : this.validateForm();
      this.isBasicError = isBasicInvalid;
      let isIpInvalid;
      let isPanelInvalid;
      let isRecruiterInValid;
      let isVendorInvalid;
      let isPublishInValid;
      if (!this.roles.includes("EXTERNAL_ACCESS")) {
        this.setFeedbackForm();
        this.$v.interviewProcess.$touch();
        this.$v.interviewProcess.feedbackFormID.$touch();
        this.$v.assessmentRounds.$touch();
        this.$v.faceToFaceRounds.$touch();
        this.$v.platformData.$touch();
        isIpInvalid =
          this.$v.interviewProcess.$invalid ||
          this.$v.interviewProcess.feedbackFormID.$invalid ||
          this.$v.assessmentRounds.$invalid ||
          this.$v.faceToFaceRounds.$invalid;
        isPublishInValid =
          this.$v.platformData.$invalid || this.interviewExceeded;
        this.$v.allocateData.assignedPanelist.$touch();
        isPanelInvalid = this.$v.allocateData.assignedPanelist.$invalid;
        isRecruiterInValid = false;
        if (this.allocateData.recruiterConfig.common) {
          this.$v.allocateData.assignedTo.$touch();
          this.$v.allocateData.recruiterConfig.panelist.$touch();
          isRecruiterInValid =
            this.$v.allocateData.assignedTo.$invalid ||
            this.$v.allocateData.recruiterConfig.panelist.$invalid;
        } else {
          this.updatePanelists();
          this.$v.currentRecuiterData.$touch();
          isRecruiterInValid = this.$v.currentRecuiterData.$invalid;
        }
        isVendorInvalid = false;
        if (
          this.allocateData.vendorConfig.common &&
          this.commonVendorData.vendor.length
        ) {
          this.$v.commonVendorData.$touch();
          isVendorInvalid = this.$v.commonVendorData.$invalid;
        } else if (!this.allocateData.vendorConfig.common) {
          this.$v.currentVendorData.$touch();
          this.$v.tempVendor.$touch();
          isVendorInvalid =
            this.$v.currentVendorData.$invalid ||
            (this.tempVendor.length !== 0 && this.$v.tempVendor.$invalid);
        }
      }
      let isAnyInvalid;
      if (this.roles.includes("EXTERNAL_ACCESS")) {
        isAnyInvalid = isBasicInvalid;
      } else {
        isAnyInvalid =
          isBasicInvalid ||
          isIpInvalid ||
          isRecruiterInValid ||
          isPanelInvalid ||
          isVendorInvalid ||
          isPublishInValid ||
          this.isAllocateError;
      }
      if (isAnyInvalid) {
        this.errorModal("Please fill all fields");
      } else if (this.platformData.automatic) {
        this.getCreditsInfo(jobStatus);
      } else {
        if (
          (this.isOnlyLeadRecruiter || this.isHMLeadPreapproved) &&
          this.isPublish
        ) {
          this.confirmModal = true;
        } else {
          this.postJob(jobStatus);
        }
      }
    },
    publishHMLeadJob() {
      this.confirmModal = false;
      if (this.isOnlyLeadRecruiter) {
        this.postJob("3");
      } else if (this.isHMLeadPreapproved) {
        this.compareJobDataHMandLead();
      }
    },
    async publishJob(jobStatus) {
      await this.postJob(jobStatus);
      this.changeStatus(jobStatus);
    },
    async changeStatus(jobStatus) {
      try {
        let payload = {
          jobID: this.jobData.jobID,
          status: jobStatus,
          remarks: "",
          publish: true,
        };
        await patchJobDesc(payload);
      } catch (error) {
        console.error(error);
      }
    },
    updatePanelists() {
      this.currentRecuiterData.forEach((recruiter) => {
        const { selectedPanels } = recruiter;

        // Determine panelist value based on selectedPanels
        recruiter.panelist =
          selectedPanels.includes("internal") &&
          selectedPanels.includes("external")
            ? "both"
            : selectedPanels.includes("internal")
            ? "internal"
            : selectedPanels.includes("external")
            ? "external"
            : null; // Reset if no selection
      });
    },
    removeUnnecessaryPanelists() {
      if (this.thirdPartyData.configuration.jobApprovalStage === "BASIC_INFO") {
        this.jobData.assignedTo = this.jobData?.assignedTo.filter(
          (rec) => rec.email
        );
      }
      this.currentRecuiterData = this.currentRecuiterData.filter(
        (recruiter) => recruiter.recruiterData !== null
      );
    },
    async checkAndUpdateConfig(process) {
      let data = [];
      for (let i of process) {
        if (i.type && i.type === "assesment" && i.configID) {
          let payload = {};
          payload.config = i.config;
          payload.config.closeTestdt = convertTime(i.closeTestdt, "utc");
          payload.config.openTestdt = convertTime(i.openTestdt, "utc");
          payload.config.testDuration = i.duration;
          payload.config.passingPercentage = i.passingPercentage;
          payload.configID = i.configID;
          payload.name = i.configName;
          payload.check = false;
          data.push(await this.updateConfig(payload));
        }
      }
      let val = data.filter((element) => element == 200);
      return data.length == 0 ? true : val.length == data.length;
    },
    checkAndConvertTime(process, format) {
      for (let i of process) {
        if (i.type && i.type === "assesment" && i.closeTestdt && i.openTestdt) {
          i.closeTestdt = convertTime(i.closeTestdt, format);
          i.openTestdt = convertTime(i.openTestdt, format);
        }
      }
      return process;
    },
    async updateConfig(payload) {
      const res = await editConfig(payload);
      return res.status;
    },
    checkValidRound(roundID) {
      const invalidRounds = [0, "F", "R", "NI", "H"];
      return !invalidRounds.includes(roundID);
    },
  },
};
</script>

<style></style>
